<template>
  <div
    id="searchbarheight"
    ref="topcontainer"
    class="search-shell sticky w-full"
    :style="{ top: topRowHeight }"
  >
    <div class="absolute z-50 -top-14 left-1/2 -translate-x-1/2 inline-block">
      <div id="savefailid"></div>
    </div>
    <div
      class="search-control mx-auto"
      :class="size"
    >
      <span class="material-symbols-outlined search-leading-icon" aria-hidden="true">
        search
      </span>
      <input
        class="search-input"
        type="search"
        id="searchbarforloggedin"
        :placeholder="placeholder"
        ref="searchbar"
        @input="keywordSearch($event.target.value)"
        @paste="$emit('pasted', $event.clipboardData.getData('text/plain'))"
        @keyup.enter="$emit('pasted', $event.target.value)"
      />
      <button
        type="button"
        class="search-submit"
        title="Search"
        @click="$emit('pasted', $refs.searchbar.value)"
      >
        <span class="material-symbols-outlined" aria-hidden="true">
          search
        </span>
      </button>
    </div>
    <div class="keyword-results-wrap mx-auto" :class="size">
      <div
        ref="keywordresults"
        class="keyword-results hidden"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: "w-11/12",
    },
    placeholder: {
      type: String,
      default: "Find puck by serial number or item keyword",
    },
  },
  inject: ["topRowHeight"],
  methods: {
    keywordSearch(searchTerm) {
      this.$refs.keywordresults.innerHTML = "";
      if (!searchTerm) return this.$refs.keywordresults.classList.add("hidden");
      this.$refs.keywordresults.classList.remove("hidden");
      console.log(searchTerm);
      const allLabs = this.appStore.state.dewarData;
      let activedewar;
      let activerack;
      // let activepuck;
      const arrayOfMatchingPucks = [];
      const arrayOfMatchingBoxes = [];
      const arrayOfMatchingGrids = [];
      for (const lab of allLabs) {
        if (!lab.data.length > 0) {
          continue;
        }

        for (const dewar of lab.data) {
          activedewar = dewar.id;
          console.log(activedewar, dewar.customId);
          if (!dewar.racks.length > 0) {
            continue;
          }
          for (const [rackindex, rack] of dewar.racks.entries()) {
            activerack = "papaBgChange3-" + rackindex;
            console.log(activerack);
            if (!rack.pucks.length > 0) {
              continue;
            }

            for (const puck of rack.pucks) {
              console.log("current puck in rack", puck.serialNo);
              // activepuck = "puck-" + puck.id;
              if (
                puck.title
                  ?.trim()
                  .toUpperCase()
                  .includes(searchTerm.trim().toUpperCase()) ||
                puck.serialNo
                  ?.trim()
                  .toUpperCase()
                  .includes(searchTerm.trim().toUpperCase()) ||
                puck.description
                  ?.trim()
                  .toUpperCase()
                  .includes(searchTerm.trim().toUpperCase()) ||
                puck.customId
                  ?.trim()
                  .toUpperCase()
                  .includes(searchTerm.trim().toUpperCase())
              ) {
                console.log("puck matchfound");
                arrayOfMatchingPucks.push({
                  item: "puck",
                  name: puck.title,
                  customId: puck.customId,
                  navId: puck.serialNo,
                  description: puck.description,
                  color: puck.color,
                });
              }

              for (let n = 1; n < 13; n++) {
                if (puck["well" + n]) {
                  const box = puck["well" + n];
                  // console.log("has well " + n);
                  if (
                    puck["well" + n].title
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase()) ||
                    puck["well" + n].description
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase()) ||
                    puck["well" + n].customId
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase())
                  ) {
                    arrayOfMatchingBoxes.push({
                      item: "box",
                      name: box.title,
                      customId: box.customId,
                      navId: puck.serialNo,
                      wellNo: n,
                      description: box.description,
                      color: box.color,
                    });
                  }

                  if (
                    puck["well" + n].gridTopLeft?.name
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase()) ||
                    puck["well" + n].gridTopLeft?.description
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase())
                  ) {
                    arrayOfMatchingGrids.push({
                      item: "grid",
                      name: puck["well" + n].gridTopLeft?.name,
                      navId: puck.serialNo,
                      wellNo: n,
                      description: puck["well" + n].gridTopLeft?.description,
                    });
                  }
                  if (
                    puck["well" + n].gridTopRight?.name
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase()) ||
                    puck["well" + n].gridTopRight?.description
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase())
                  ) {
                    arrayOfMatchingGrids.push({
                      item: "grid",
                      name: puck["well" + n].gridTopRight?.name,
                      navId: puck.serialNo,
                      wellNo: n,
                      description: puck["well" + n].gridTopRight?.description,
                    });
                  }
                  if (
                    puck["well" + n].gridBottomLeft?.name
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase()) ||
                    puck["well" + n].gridBottomLeft?.description
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase())
                  ) {
                    arrayOfMatchingGrids.push({
                      item: "grid",
                      name: puck["well" + n].gridBottomLeft?.name,
                      navId: puck.serialNo,

                      wellNo: n,

                      description: puck["well" + n].gridBottomLeft?.description,
                    });
                  }
                  if (
                    puck["well" + n].gridBottomRight?.name
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase()) ||
                    puck["well" + n].gridBottomRight?.description
                      ?.trim()
                      .toUpperCase()
                      .includes(searchTerm.trim().toUpperCase())
                  ) {
                    arrayOfMatchingGrids.push({
                      item: "grid",
                      name: puck["well" + n].gridBottomRight?.name,
                      navId: puck.serialNo,
                      wellNo: n,
                      description:
                        puck["well" + n].gridBottomRight?.description,
                    });
                  }
                }
              }
            }
          }
        }
      }
      let limit = 0;

      const parentContainerMain = document.createElement("div");
      parentContainerMain.classList.add(
        "flex",
        "cursor-pointer",
        "border",
        "rounded",
        "border-black",
        "items-center",
        "bg-white",
        "mb-2"
      );
      arrayOfMatchingPucks.forEach((puck) => {
        if (limit == 10) return;
        const parentContainer = parentContainerMain.cloneNode();

        const itemType = document.createElement("div");
        itemType.style = `background-color:${this.appStore.state.transformPuckColor(
          puck.color
        )}`;
        itemType.classList.add("rounded", "px-2", "py-1", "mr-4");
        itemType.textContent = "Puck";
        parentContainer.appendChild(itemType);
        const nameDiv = document.createElement("div");
        nameDiv.textContent = puck.name;
        parentContainer.appendChild(nameDiv);
        const customId = document.createElement("div");
        customId.textContent = `(${puck.customId ?? puck.navId})`;
        parentContainer.appendChild(customId);

        const description = document.createElement("div");
        description.classList.add("ml-4", "text-sm", "truncate");
        description.textContent = puck.description;
        parentContainer.appendChild(description);
        // const color = document.createElement("div");
        // color.innerHTML = `<span style="color:${puck.color}">${puck.color}</span>`;
        // parentContainer.appendChild(color);
        parentContainer.addEventListener("click", () => {
          this.$emit("pasted", puck.navId);
          this.$refs.keywordresults.classList.add("hidden");
          if (document.getElementById("searchbarforloggedin")) {
            document.getElementById("searchbarforloggedin").value = "";
          }
        });
        this.$refs.keywordresults.appendChild(parentContainer);
        limit++;
      });
      arrayOfMatchingBoxes.forEach((box) => {
        if (limit == 10) return;
        const parentContainer = parentContainerMain.cloneNode();
        const itemType = document.createElement("div");
        itemType.style = `background-color:${this.appStore.state.transformBoxColor(
          box.color
        )}`;
        itemType.classList.add("rounded", "px-2", "py-1", "mr-4");
        itemType.textContent = "Box";
        parentContainer.appendChild(itemType);
        const nameDiv = document.createElement("div");
        nameDiv.textContent = box.name;
        parentContainer.appendChild(nameDiv);
        if (box.customId) {
          const customId = document.createElement("div");

          customId.textContent = `(${box.customId})`;
          parentContainer.appendChild(customId);
        }

        const description = document.createElement("div");
        description.classList.add("ml-4", "text-sm", "truncate");
        description.textContent = box.description;
        parentContainer.appendChild(description);
        // const color = document.createElement("div");
        // color.innerHTML = `<span style="color:${puck.color}">${puck.color}</span>`;
        // parentContainer.appendChild(color);
        console.log(box.navId, box.wellNo);
        parentContainer.addEventListener("click", () => {
          this.$emit("pasted", box.navId, box.wellNo);
          this.$refs.keywordresults.classList.add("hidden");
          if (document.getElementById("searchbarforloggedin")) {
            document.getElementById("searchbarforloggedin").value = "";
          }
        });
        this.$refs.keywordresults.appendChild(parentContainer);
        limit++;
      });

      arrayOfMatchingGrids.forEach((grid) => {
        if (limit == 10) return;
        const parentContainer = parentContainerMain.cloneNode();
        const itemType = document.createElement("div");

        itemType.classList.add(
          "rounded",
          "px-2",
          "py-1",
          "mr-4",
          "bg-gray-300"
        );
        itemType.textContent = "Grid";
        parentContainer.appendChild(itemType);
        const nameDiv = document.createElement("div");
        nameDiv.textContent = grid.name;
        parentContainer.appendChild(nameDiv);

        const description = document.createElement("div");
        description.textContent = grid.description;
        description.classList.add("ml-4", "text-sm", "truncate");
        parentContainer.appendChild(description);
        // const color = document.createElement("div");
        // color.innerHTML = `<span style="color:${puck.color}">${puck.color}</span>`;
        // parentContainer.appendChild(color);
        parentContainer.addEventListener("click", () => {
          console.log("clickity", grid.navId, grid.wellNo);
          this.$emit("pasted", grid.navId, grid.wellNo, true);

          this.$refs.keywordresults.classList.add("hidden");
          if (document.getElementById("searchbarforloggedin")) {
            document.getElementById("searchbarforloggedin").value = "";
          }
        });
        this.$refs.keywordresults.appendChild(parentContainer);
        limit++;
      });

      if (
        !arrayOfMatchingPucks.length &&
        !arrayOfMatchingBoxes.length &&
        !arrayOfMatchingGrids.length
      ) {
        const aDiv = document.createElement("div");
        aDiv.textContent = "No results found";
        this.$refs.keywordresults.appendChild(aDiv);
      }

      this.$refs.keywordresults.lastElementChild.style = "margin-bottom:0";
    },
  },

  mounted() {
    console.log("fromsearch", this.topRowHeight);
    this.$refs.searchbar.focus();
  },
};
</script>

<style scoped>
.search-shell {
  z-index: 50;
  padding: 12px 0 10px;
  background: #fff;
}

.home-search-width {
  width: min(920px, 92vw);
}

.search-control {
  display: grid;
  grid-template-columns: 26px minmax(0, 1fr) 44px;
  align-items: center;
  min-height: 42px;
  border: 1px solid #9db4d0;
  border-radius: 7px;
  background: #fff;
  color: #526173;
  box-shadow: inset 0 0 0 1px rgb(255 255 255 / 0.85), 0 1px 2px rgb(15 23 42 / 0.08);
}

.search-control:focus-within {
  border-color: #6889b3;
  box-shadow: 0 0 0 3px rgb(51 92 139 / 0.12), 0 3px 10px rgb(15 23 42 / 0.1);
}

.search-leading-icon {
  justify-self: end;
  color: #5e7188;
  font-size: 22px;
}

.search-input {
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0 8px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #172033;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
}

.search-input::placeholder {
  color: #71839a;
  opacity: 1;
}

.search-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 32px;
  margin: 0 5px 0 0;
  border: 1px solid #d5dfec;
  border-radius: 6px;
  background: #f8fafc;
  color: #335c8b;
  cursor: pointer;
}

.search-submit:hover,
.search-submit:focus-visible {
  border-color: #8fb0d4;
  background: #eef6ff;
  outline: 0;
}

.search-submit .material-symbols-outlined {
  font-size: 21px;
}

.keyword-results-wrap {
  position: relative;
}

.keyword-results {
  position: absolute;
  top: 6px;
  left: 0;
  z-index: 10;
  width: 100%;
  max-height: min(430px, calc(100vh - 120px));
  overflow: auto;
  padding: 8px;
  border: 1px solid #d5dfec;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 18px 36px rgb(15 23 42 / 0.18);
}

.truncate {
  flex: 1;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
